import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import routes from '../../../../routes';
import SeniorIndividualPrints from '../../../PackageBuilders/SeniorIndividualPrints/SeniorIndividualPrints';
import useOrderPackage from '../../../../hooks/useOrderPackage';
import { useCustomer } from '../../../../contexts/CustomerContext';

export default function IndividualPrints() {
  const { orderPackageId } = useParams();
  const { data: orderPackage } = useOrderPackage(orderPackageId);
  const { customer, setCustomer } = useCustomer();
  const history = useHistory();

  const onSave = () => {
    setCustomer({ ...customer, currentOrderPackage: orderPackage });

    history.push(routes.confirm(orderPackage.id));
  };

  if (!orderPackage) return null;

  return <SeniorIndividualPrints orderPackageId={orderPackage.id} onSave={onSave} />;
}
